import { useTranslation } from "react-i18next";
import { Drawer, DrawerClose, DrawerContent } from "@/components/ui/drawer.tsx";
import IconClose from "@/assets/icons/close.svg?react";
import IconAlertTriangle from "@/assets/icons/alert-triangle.svg?react";
import IconDiamondCircle from "@/assets/icons/diamond-circle-linear.svg?react";

interface StreakSavedModalProps {
  isOpen: boolean;
  previousDayNumber: number;
  currentDayNumber: number;
  onClose: () => void;
  onClaim: () => void;
  /** Kept for API compat with the old celebratory version — ignored now
   *  that the sheet is a warning. */
  celebrate?: boolean;
}

/* "Seriya uzilishdan saqlandi" — premium-grace bottom sheet, styled to the
   Figma "DON Home / History / Single /Check" frame (node 22860:9298):
   amber alert badge, title + subtitle, an amber diamond note card, and a
   gold gradient "DON olish" button. */

const StreakSavedModal = ({ isOpen, onClose, onClaim }: StreakSavedModalProps) => {
  const { t } = useTranslation();

  return (
    <Drawer open={isOpen} onOpenChange={(e) => !e && onClose()}>
      <DrawerContent className="bg-gray-4" showTopThumb>
        <div className="flex justify-end px-4 pt-1">
          <DrawerClose>
            <IconClose className="size-6 text-gray-1 cursor-pointer" />
          </DrawerClose>
        </div>

        <div className="px-4 pb-safe-bottom pt-1 flex flex-col items-center gap-5">
          {/* Amber alert badge — glow ring + tinted disc with border. */}
          <div className="relative size-[100px] flex items-center justify-center shrink-0">
            <span className="absolute inset-0 rounded-full bg-orange-100/[0.08]" />
            <span className="absolute inset-[9px] rounded-full bg-orange-100/20 border border-orange-100/50 flex items-center justify-center">
              <IconAlertTriangle className="size-11 text-orange-100" />
            </span>
          </div>

          {/* Title + subtitle. */}
          <div className="flex flex-col items-center text-center gap-1.5">
            <h2 className="text-xl font-semibold text-white leading-130">
              {t("streak_saved_modal_title")}
            </h2>
            <p className="text-sm font-normal text-white leading-130">
              {t("premium_grace_reminder", {
                defaultValue:
                  "Esingizdan chiqdi! Premium imtiyozingiz tufayli seriyangiz buzilmaydi — bugun albatta oling! 💎",
              })}
            </p>
          </div>

          <div className="w-full flex items-center gap-3 rounded-xl bg-orange-100/08 border border-orange-100 p-3">
            <span className="shrink-0 rounded-full  flex items-center justify-center">
              <IconDiamondCircle className="size-[39px]"/>
            </span>
            <p className="text-[11px] font-medium text-white leading-130">
              {t("premium_grace_protection_note", {
                defaultValue:
                  "Streak himoyasi faol! Premium foydalanuvchi sifatida 1 kun o'tkazib yuborishingiz mumkin, lekin ertaga yo'q! 🛡",
              })}
            </p>
          </div>
          <button
            type="button"
            onClick={onClaim}
            className="w-full h-11 rounded-xl bg-yellow-linear text-black text-sm font-bold flex items-center justify-center active:opacity-90 transition-opacity"
          >
            {t("get_don")}
          </button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default StreakSavedModal;
